import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useMetaMask from "hooks/metsmask";
import { putProfile } from "store/actions";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import { Button, Container } from "react-bootstrap";

export default function Metamasksign() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { Login } = useSelector((state) => state);
  const { user } = useSelector((state) => state?.Login);

  let [state, setstate] = useState(null);
  let hooks = useMetaMask();
  let myObj = [];
  const callback = (res)=>{
  }
  const setCookie = async (walletType) => {
    myObj = await hooks?.connect(walletType);
    if (myObj) {
      if(myObj?.address){
        dispatch(
          putProfile(
            { walletAddress: myObj?.address },(res)=>{
              window.history.back()
            }
            // navigate(`../profile/home`)
          
            )
           
        );
        setTimeout(toastr.success("Connected successfully"), 5000);
      }else{
        setTimeout(toastr.warning("Please allow metamask for Terpnash"), 1000);
      }
      
      // 
      // 
    }
  };

  useEffect(() => {
    setstate(hooks);
  }, [hooks]);

  return (
    <section className="Metamasksign-main">
      <Container>
        <div className="metamaksign-here">
          <div className="DigitalArtcollection-head text-center">
            <h2>Connect To</h2>
            <p>
              Choose one of available wallet providers or create a new wallet.
              
              {/* What is a wallet? */}
            </p>
          </div>

          <div className="metabox">
            {/* <p className="plolyselct">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M15.6665 10.8208V8.84667C16.1525 8.67525 16.5735 8.35771 16.8719 7.93758C17.1703 7.51745 17.3314 7.01531 17.3332 6.5C17.3332 5.12167 16.2115 4.00001 14.8332 4.00001C14.5057 3.99984 14.1814 4.06423 13.8788 4.18949C13.5763 4.31475 13.3014 4.49842 13.0698 4.73L9.80734 3.425C9.81567 3.33917 9.83317 3.25501 9.83317 3.16667C9.83317 1.78834 8.7115 0.666672 7.33317 0.666672C5.95484 0.666672 4.83317 1.78834 4.83317 3.16667C4.83317 3.80167 5.079 4.37584 5.47067 4.8175L4.07567 6.67667C3.78639 6.56123 3.47796 6.5013 3.1665 6.5C1.78817 6.5 0.666504 7.62167 0.666504 9C0.666504 10.3783 1.78817 11.5 3.1665 11.5C3.299 11.5 3.42734 11.4808 3.554 11.4608L5.1665 13.61C4.95984 13.9733 4.83317 14.3867 4.83317 14.8333C4.83317 16.2117 5.95484 17.3333 7.33317 17.3333C7.87112 17.3315 8.39406 17.1558 8.82401 16.8324C9.25396 16.5091 9.5679 16.0555 9.719 15.5392L13.0207 14.8792C13.253 15.1272 13.5337 15.3251 13.8454 15.4605C14.1571 15.5959 14.4933 15.6661 14.8332 15.6667C16.2115 15.6667 17.3332 14.545 17.3332 13.1667C17.3315 12.6515 17.1704 12.1494 16.872 11.7294C16.5735 11.3094 16.1525 10.992 15.6665 10.8208ZM14.8332 5.66667C14.9982 5.66651 15.1596 5.71531 15.2969 5.80691C15.4342 5.8985 15.5413 6.02877 15.6045 6.18123C15.6678 6.33369 15.6843 6.50148 15.6522 6.66337C15.62 6.82526 15.5406 6.97397 15.4238 7.09068C15.3071 7.20739 15.1584 7.28686 14.9965 7.31902C14.8346 7.35118 14.6669 7.33459 14.5144 7.27135C14.3619 7.20811 14.2317 7.10106 14.1401 6.96376C14.0485 6.82645 13.9997 6.66506 13.9998 6.5C13.9998 6.04084 14.3732 5.66667 14.8332 5.66667ZM7.33317 2.33334C7.49822 2.33317 7.65962 2.38198 7.79692 2.47357C7.93423 2.56517 8.04127 2.69544 8.10451 2.8479C8.16775 3.00036 8.18434 3.16815 8.15218 3.33004C8.12002 3.49193 8.04056 3.64064 7.92385 3.75735C7.80714 3.87406 7.65843 3.95352 7.49654 3.98568C7.33465 4.01784 7.16685 4.00125 7.0144 3.93801C6.86194 3.87478 6.73167 3.76773 6.64007 3.63042C6.54848 3.49312 6.49967 3.33173 6.49984 3.16667C6.49984 2.7075 6.87317 2.33334 7.33317 2.33334ZM2.33317 9C2.33301 8.83495 2.38181 8.67356 2.47341 8.53625C2.565 8.39895 2.69527 8.2919 2.84773 8.22866C3.00019 8.16542 3.16798 8.14883 3.32987 8.18099C3.49176 8.21315 3.64047 8.29262 3.75718 8.40933C3.87389 8.52604 3.95336 8.67475 3.98552 8.83664C4.01768 8.99853 4.00109 9.16632 3.93785 9.31878C3.87461 9.47124 3.76756 9.60151 3.63026 9.6931C3.49295 9.7847 3.33156 9.8335 3.1665 9.83334C2.7065 9.83334 2.33317 9.45917 2.33317 9ZM7.33317 15.6667C7.11216 15.6667 6.9002 15.5789 6.74392 15.4226C6.58763 15.2663 6.49984 15.0544 6.49984 14.8333C6.49984 14.6123 6.58763 14.4004 6.74392 14.2441C6.9002 14.0878 7.11216 14 7.33317 14C7.55418 14 7.76615 14.0878 7.92243 14.2441C8.07871 14.4004 8.1665 14.6123 8.1665 14.8333C8.1665 15.0544 8.07871 15.2663 7.92243 15.4226C7.76615 15.5789 7.55418 15.6667 7.33317 15.6667ZM9.634 13.8567C9.44186 13.4053 9.12138 13.0203 8.71234 12.7495C8.3033 12.4787 7.82373 12.334 7.33317 12.3333C7.0115 12.3333 6.7065 12.3992 6.424 12.5108L5.029 10.6517C5.42067 10.2092 5.6665 9.635 5.6665 9C5.6665 8.55334 5.53984 8.14001 5.334 7.7775L6.9465 5.6275C7.07317 5.6475 7.20067 5.66667 7.33317 5.66667C7.66064 5.66684 7.98493 5.60245 8.2875 5.47719C8.59007 5.35193 8.86497 5.16826 9.0965 4.93667L12.359 6.24167C12.3507 6.3275 12.3332 6.41167 12.3332 6.5C12.3332 7.585 13.0323 8.50084 13.9998 8.84584V10.82C13.5139 10.9913 13.0929 11.3087 12.7945 11.7287C12.4962 12.1486 12.335 12.6506 12.3332 13.1658C12.3332 13.2167 12.3457 13.2633 12.3482 13.3133L9.634 13.8567ZM14.8332 14C14.6122 14 14.4002 13.9122 14.2439 13.7559C14.0876 13.5996 13.9998 13.3877 13.9998 13.1667C13.9998 12.9457 14.0876 12.7337 14.2439 12.5774C14.4002 12.4211 14.6122 12.3333 14.8332 12.3333C15.0542 12.3333 15.2661 12.4211 15.4224 12.5774C15.5787 12.7337 15.6665 12.9457 15.6665 13.1667C15.6665 13.3877 15.5787 13.5996 15.4224 13.7559C15.2661 13.9122 15.0542 14 14.8332 14Z"
                  fill="black"
                />
              </svg>
              Polygon
            </p> */}

            <Button
              className="fox-img py-0"
              onClick={() => setCookie("metamask")}
              loading={Login?.loading}
            >
              <img src="images/svg/MetaMask_2.svg" alt=""  className="img-fluid" />
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
